module.exports = __webpack_public_path__ + "static/media/Scragg Nip Roller Bearing --.8306a6bf.jpg";